/**
 * Create jQuery children of data-node
 * @example
 var stringChilds = $_GP.dataNode('#some-it') // need data-node="string"
 stringChilds.el('title') // selects all data-node-string="title"

 * @param {string|jQuery} elm - string id or jQuery element
 * @requires elm need data-node="something"
 * @returns {object} with methods
**/
export function dataNode(elm) {
	elm = $(elm);
	if (!elm.length) return;
	elm = elm.eq(0);
	const nodeExt = elm.data('node')

	return {
		el(nodeName) {
			return elm.find(`[data-node-${nodeExt}="${nodeName}"]`)
		}
	}
}

/**
 * Add extra funcionality to jQuery with de selector data-se
**/
export function dataSelector() {
	/**
	 * Shortcut for data-se selector
	 * @param {string} value dom node data attribute data-se value
	 * @param {HTMLElemet} ctx jQuery selector context
	*/
	function $$(value,ctx) {
		return $(`[data-se="${value}"]`, ctx)
	}

	window.$$ = $$

	$.fn.find$$ = function(value) {
		return this.find(`[data-se="${value}"]`)
	}

	$.fn.closest$$ = function(value) {
		return this.closest(`[data-se="${value}"]`)
	}
}
